import { useContext } from "react";
import CompanyService from "../../../services/CompanyService";
import { formatCurrency } from "../../../utils/FormatUtils";
import { TranslationService } from "../../../services/TranslationService";
import TableContext from "../../task/TableContext";

const ClientTableTotal = () => {
  const { response } = useContext(TableContext);
  const { translate } = TranslationService;
  return (
    <tr className={"font-weight-bold"} style={{ backgroundColor: "#ddedf9" }}>
      <td>{translate.Total}</td>
      <td className={"text-end"}>{response.iocount ?? 0}</td>
      <td className={"text-end"}>
        {formatCurrency(
          response.total ?? 0,
          CompanyService.getDefaultCurrencyId()
        )}
      </td>
      <td className={"text-end"}></td>
      <td className={"text-end"}></td>
      <td className={"text-end"}></td>
    </tr>
  );
};

export default ClientTableTotal;
